import { render, staticRenderFns } from "./StartKrachDialog.vue?vue&type=template&id=6f2fff26&"
import script from "./StartKrachDialog.vue?vue&type=script&lang=js&"
export * from "./StartKrachDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports